import { useState } from "react";
import { CalendarClock, Download, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, useLoad } from "@/lib/api";
import { downloadExcel } from "@/lib/exportData";

const when = (iso) => new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" });

export default function WeeklyBackup() {
  const { data, reload } = useLoad("/backup/status", null);
  const [busy, setBusy] = useState(false);
  const sendNow = async () => {
    setBusy(true);
    try { const r = await api.post("/backup/email-now"); toast.success(`Backup emailed to ${r.data.recipients.join(", ")}`); reload(); }
    catch (e) { toast.error(errMsg(e, "Could not email the backup")); } finally { setBusy(false); }
  };
  return (
    <section className="backup-card stacked" data-testid="backup-card">
      <div className="backup-top">
        <div><h3>Backup & export</h3><p className="muted">Every patient, payment, treatment, clinical note, appointment, lab entry and expense of this clinic in one Excel file.</p></div>
        <div className="share-row">
          <button className="secondary" onClick={downloadExcel} data-testid="export-excel-button"><Download size={16} /> Download Excel</button>
          <button className="primary" onClick={sendNow} disabled={busy} data-testid="email-backup-now-button"><Mail size={16} /> {busy ? "Sending…" : "Email backup now"}</button>
        </div>
      </div>
      {data && <div className="auto-backup" data-testid="auto-backup-info">
        <p><CalendarClock size={15} /> <b>Automatic email backup:</b> <span data-testid="auto-backup-schedule">{data.schedule}</span></p>
        <p className="muted" data-testid="auto-backup-recipients">Sent to all clinic admins: {data.recipients.length ? data.recipients.map((r) => r.email).join(", ") : "no admin email found"}</p>
        {data.history.length > 0 && <ul className="backup-log" data-testid="backup-history">
          {data.history.map((h) => <li key={h.id} data-testid={`backup-log-${h.id}`}><span className={`badge ${h.status === "sent" ? "completed" : "cancelled"}`}>{h.status}</span> {when(h.at)} · {h.trigger === "weekly" ? "Weekly" : "Manual"}{h.recipients.length ? ` · ${h.recipients.length} admin(s)` : ""}{h.error ? ` · ${h.error}` : ""}</li>)}
        </ul>}
      </div>}
    </section>
  );
}
